import Vue from 'vue';
import CompositionAPI from '@vue/composition-api';
import TDesign from 'tdesign-vue';
import 'tdesign-vue/es/style/index.css';
import './style.scss';

Vue.use(CompositionAPI);
Vue.use(TDesign);
